import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import { useEffect, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import commonUtils from '@/utils/commonUtils'
import { Button, FormGroup, Input, Label, Select } from '@/components'
import { TInput } from '@/components/forms/form-elements/types'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'

interface HistDataRow {
  bizCd: string //업체코드
  bizNm: string //업체명
  baseDt: string //기준일자
  glfPrceCd: string //골프장가격코드
  glfPrceNm: string //골프장가격명
  batchSeq?: string
  seq: string //순번
  curr: string //통화단위
  oldPrce?: string //이전가격
  newPrce?: string //신규가격
  updtYn: string //업데이트 여부
  statInclYn: string //통계포함여부
  rem?: string //비고
  errDtl?: string
  updId: string
  updDate: string
}

interface DataRow {
  bizCd: string //업체코드
  bizNm: string //업체명
  baseDomain?: string
  chrgeDomain?: string
  baseDt: string //기준일자
  n01Seq: string
  n02Seq: string
  m01Seq: string
  m02Seq: string
  n01: string
  n02: string
  m01: string
  m02: string
  rem: string
  updId: string
  updDate: string
  glfPrceCd: string
}

interface DeleteTargetData {
  bizCd: string
  seq: string
  glfPrceCd: string
}
interface SelectedRowData {
  bizCd: string
  baseDt: string
}
const PriceIntgMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showAlert, showConfirm } = useDialog()
  const { getComCodes, getComCodeValue } = useRedis()
  const [bizList, setBizList] = useState<any[]>([])
  const [origin, setOrigin] = useState<DataRow[]>([]) // 원본데이터
  const [datas, setDatas] = useState<DataRow[]>([]) // 변경할데이터
  const [changeFields, setChangeFields] = useState<any[]>([])

  const [perPage, setPerPage] = useState(50)
  const [currentPage, setCurrentPage] = useState(1)

  const [searchParams] = useSearchParams()
  //체크박스
  const [selectedRows, setSelectedRows] = useState<SelectedRowData[]>([]) // 전체 선택 상태 관리
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [bizCd, setBizCd] = useState('')
  const today = new Date()
  const before1Month = new Date()
  before1Month.setMonth(today.getMonth() - 1)
  const before1Week = new Date()
  before1Week.setDate(today.getDate() - 7)
  const janFirst = new Date()
  janFirst.setMonth(0)
  janFirst.setDate(1)
  const twoMonthsLater = new Date(today)
  twoMonthsLater.setMonth(today.getMonth() + 2)
  const before2Months = new Date() // 새로 추가
  before2Months.setMonth(today.getMonth() - 2) // 2달 전으로 설정

  const [searchData, setSearchData] = useState({
    areaCd: '',
    bizNm:
      searchParams && searchParams.get('bizNm')
        ? searchParams.get('bizNm') || ''
        : '',
    inqyStartDate:
      searchParams && searchParams.get('bizNm')
        ? //janFirst.toISOString().split('T')[0]
          before2Months.toISOString().split('T')[0]
        : before1Week.toISOString().split('T')[0],
    inqyEndDate: twoMonthsLater.toISOString().split('T')[0], // 오늘 기준 2달 후
    glfPrceCd: 'N01',
    minPrce: '',
    maxPrce: '',
    manualYn: '',
  })

  const initHistSearch = {
    glfPrceCd: '',
    updtYn: '',
    statInclYn: '',
  }
  const [searchHistData, setSearchHistData] = useState(initHistSearch)

  const initInsertSearch = {
    bizCd: '',
    n01: '',
    n02: '',
    m01: '',
    m02: '',
    updtYn: '',
    statInclYn: '',
  }
  const [searchInsertData, setSearchInsertData] = useState(initInsertSearch)

  // 이력목록
  const [showHistList, setShowHistList] = useState(false)
  const [histOrigin, setHistOrigin] = useState<HistDataRow[]>([]) // 원본데이터
  const [histDatas, setHistDatas] = useState<HistDataRow[]>([]) // 변경할데이터
  const [histChangeFields, setHistChangeFields] = useState<any[]>([]) // TODO ?
  const [targetHistData, setTargetHistData] = useState<DataRow>()

  // 이력등록
  const initInsertData: DataRow = {
    bizCd: '',
    bizNm: '',
    baseDt: commonUtils.dateStrChgFomat(
      today.toISOString().split('T')[0],
      'yyyy-MM-dd',
    ),
    m01: '',
    m01Seq: '-1',
    m02: '',
    m02Seq: '-1',
    n01: '',
    n01Seq: '-1',
    n02: '',
    n02Seq: '-1',
    rem: '',
    updDate: '',
    updId: '',
    glfPrceCd: '',
  }
  const [showInsert, setShowInsert] = useState(false)
  const [insertDatas, setInsertDatas] = useState<DataRow[]>([])

  // 일괄적용
  const [applyData, setApplyData] = useState({
    n01: '',
    n02: '',
    m01: '',
    m02: '',
  })
  // 일괄적용
  const [applyInsertData, setApplyInsertData] = useState({
    n01: '',
    n02: '',
    m01: '',
    m02: '',
    rem: '',
  })

  const handleInputChange = (e: React.ChangeEvent<TInput>, row: DataRow) => {
    const { name, value } = e.target
    let rawValue: any = value
    if (name === 'n01' || name === 'n02' || name === 'm01' || name === 'm02') {
      rawValue = Number(e.target.value.replace(/[^0-9]/g, '') || 0)
    }

    const rowIndex = datas.findIndex(
      (data) => data.baseDt == row.baseDt && data.bizCd == row.bizCd,
    )
    if (rowIndex < 0) {
      return
    }

    setDatas((prevItems) => {
      const newDatas = [...prevItems]
      newDatas[rowIndex] = {
        ...newDatas[rowIndex],
        [name]: rawValue,
      }
      return newDatas
    })

    const originValue: any = origin[rowIndex]
    const isChange = !originValue || originValue[name] != rawValue

    setChangeFields((prevItems) => {
      const newDatas = [...prevItems]
      newDatas[rowIndex] = {
        ...newDatas[rowIndex],
        [name]: isChange,
      }
      return newDatas
    })
  }

  const handleInsertInputChange = (
    e: React.ChangeEvent<TInput>,
    rowIndex: number,
  ) => {
    const { name, value } = e.target
    let rawValue: any = value
    if (name === 'n01' || name === 'n02' || name === 'm01' || name === 'm02') {
      rawValue = Number(e.target.value.replace(/[^0-9]/g, '') || 0)
    }

    // const rowIndex = insertDatas.findIndex(data => data.baseDt == row.baseDt && data.bizCd == row.bizCd)
    // if (rowIndex < 0) {
    //   return;
    // }

    setInsertDatas((prevItems) => {
      const newDatas = [...prevItems]
      newDatas[rowIndex] = {
        ...newDatas[rowIndex],
        [name]: rawValue,
      }
      return newDatas
    })
  }

  const handleSearchChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    let rawValue: any = value
    if (name === 'minPrce' || name === 'maxPrce') {
      rawValue =
        value.replace(/[^0-9]/g, '') == ''
          ? ''
          : Number(value.replace(/[^0-9]/g, '') || 0)
    }
    setSearchData((prevState) => {
      return {
        ...prevState,
        [name]: rawValue,
      } // 모든 필드를 포함하는 상태를 유지
    })
  }

  const handleHistSearchChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    const key = name as keyof HistDataRow
    setSearchHistData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      } // 모든 필드를 포함하는 상태를 유지
    })

    const searchConditions: Partial<HistDataRow> = {
      ...searchHistData,
      [name]: value,
    }

    setHistDatas(
      histOrigin.filter((data) =>
        Object.entries(searchConditions).every(
          ([key, value]) => data[key as keyof HistDataRow] === value || !value,
        ),
      ),
    )
  }

  const handleInsertSearchChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setSearchInsertData((prevState) => {
      return {
        ...prevState,
        [name]: value,
      } // 모든 필드를 포함하는 상태를 유지
    })

    // setHistDatas(histOrigin.filter((data) => data[key] == value || !value));
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      getData()
    }
  }

  const handleApplyChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    let rawValue: any = value
    if (name === 'n01' || name === 'n02' || name === 'm01' || name === 'm02') {
      rawValue =
        value.replace(/[^0-9]/g, '') == ''
          ? ''
          : Number(value.replace(/[^0-9]/g, '') || 0)
    }
    setApplyData((prevState) => {
      return {
        ...prevState,
        [name]: rawValue,
      } // 모든 필드를 포함하는 상태를 유지
    })
  }

  const handleApplyInsertChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    let rawValue: any = value
    if (name === 'n01' || name === 'n02' || name === 'm01' || name === 'm02') {
      rawValue =
        value.replace(/[^0-9]/g, '') == ''
          ? ''
          : Number(value.replace(/[^0-9]/g, '') || 0)
    }
    setApplyInsertData((prevState) => {
      return {
        ...prevState,
        [name]: rawValue,
      } // 모든 필드를 포함하는 상태를 유지
    })
  }

  const handleApplyButton = () => {
    setDatas((prevItems) =>
      prevItems.map((data) => ({
        ...data,
        n01: !data.n01 ? '' : applyData.n01 != '' ? applyData.n01 : data.n01,
        n02: !data.n02 ? '' : applyData.n02 != '' ? applyData.n02 : data.n02,
        m01: !data.m01 ? '' : applyData.m01 != '' ? applyData.m01 : data.m01,
        m02: !data.m02 ? '' : applyData.m02 != '' ? applyData.m02 : data.m02,
      })),
    )

    const newChanges = datas.map((data, i) => ({
      n01:
        !!data.n01 &&
        (applyData.n01 != '' ? applyData.n01 : data.n01) != origin[i].n01,
      n02:
        !!data.n02 &&
        (applyData.n02 != '' ? applyData.n02 : data.n02) != origin[i].n02,
      m01:
        !!data.m01 &&
        (applyData.m01 != '' ? applyData.m01 : data.m01) != origin[i].m01,
      m02:
        !!data.m02 &&
        (applyData.m02 != '' ? applyData.m02 : data.m02) != origin[i].m02,
    }))

    setChangeFields(newChanges)
  }

  const handleInsertApplyButton = () => {
    setInsertDatas((prevItems) =>
      prevItems.map((data) => ({
        ...data,
        n01: applyInsertData.n01 != '' ? applyInsertData.n01 : data.n01,
        n02: applyInsertData.n02 != '' ? applyInsertData.n02 : data.n02,
        m01: applyInsertData.m01 != '' ? applyInsertData.m01 : data.m01,
        m02: applyInsertData.m02 != '' ? applyInsertData.m02 : data.m02,
        rem: applyInsertData.rem != '' ? applyInsertData.rem : data.rem,
      })),
    )
  }

  const handleInsertButtonClick = () => {
    setShowHistList(false)
    setShowInsert(true)
    setInsertDatas([])
    setSearchInsertData({
      ...initInsertSearch,
      bizCd:
        datas && datas.length > 0
          ? bizList.find((biz) => biz.bizNm == datas[0].bizNm).bizCd
          : '',
    })
    setApplyInsertData({
      n01: '',
      n02: '',
      m01: '',
      m02: '',
      rem: '',
    })
  }
  const handleResetButtonClick = (row: DataRow) => {
    const rowIndex = datas.findIndex(
      (data) => data.baseDt == row.baseDt && data.bizCd == row.bizCd,
    )
    if (rowIndex < 0) {
      return
    }

    setDatas((prevItems) => {
      const newDatas = [...prevItems]
      newDatas[rowIndex] = origin[rowIndex]
      return newDatas
    })
    setChangeFields((prevItems) => {
      const newDatas = [...prevItems]
      newDatas[rowIndex] = {}
      return newDatas
    })
  }

  // 통합가격관리 일괄삭제 버튼 핸들러
  // const handleDeleteIntg = () => {
  //   if (selectedRows.length > 0) {
  //     // 선택된 행이 있는 경우 - 선택 삭제
  //     console.log('선택된 데이터:', selectedRows)

  //     showConfirm({
  //       message: `선택된 ${selectedRows.length}개의 가격이력을 삭제할까요?`,
  //       onConfirm: () => {
  //         handleSelectedDelete(selectedRows) // selectedRows를 직접 전달
  //       },
  //     })
  //   } else {
  //     // 선택된 행이 없는 경우 - 일괄삭제
  //     showConfirm({
  //       message: '현재 검색된 모든 가격이력을 삭제할까요?',
  //       onConfirm: () => {
  //         handleAllDelete()
  //       },
  //     })
  //   }
  // }

  // 선택삭제 핸들러
  const handleSelectedDeleteClick = () => {
    if (selectedRows.length === 0) {
      showAlert({
        type: 'warning',
        message: '삭제할 항목을 선택해주세요.',
      })
      return
    }

    showConfirm({
      message: `선택된 ${selectedRows.length}개의 가격이력을 삭제할까요?`,
      onConfirm: () => {
        handleSelectedDelete(selectedRows)
      },
    })
  }

  // 전체삭제 핸들러
  // const handleAllDeleteClick = () => {
  //   showConfirm({
  //     message: '현재 검색된 모든 가격이력을 삭제할까요?',
  //     onConfirm: () => {
  //       handleAllDelete()
  //     },
  //   })
  // }

  const handleAllDeleteClick = () => {
    showConfirm({
      title: '전체삭제',
      message:
        '⚠️ 현재 검색된 모든 가격이력을 삭제할까요?\n계속하려면 "전체삭제"라고 입력하세요.',
      confirmBtnName: '삭제하기',
      cancelBtnName: '취소',
      inputPlaceholder: '전체삭제',
      inputRequired: true,
      inputValidator: (value) => {
        return value === '전체삭제' || '"전체삭제"라고 정확히 입력하세요.'
      },
      onConfirm: (inputValue) => {
        handleAllDelete()
      },
    })
  }
  // 데이터 변환 함수
  // const convertToDeleteData = (rowData: DataRow): DeleteTargetData[] => {
  //   const deleteItems: DeleteTargetData[] = []

  //   // 각 price code별로 seq가 있으면 삭제 대상에 추가
  //   if (rowData.n01Seq) {
  //     deleteItems.push({
  //       bizCd: rowData.bizCd,
  //       seq: rowData.n01Seq,
  //       glfPrceCd: 'N01',
  //     })
  //   }

  //   if (rowData.n02Seq) {
  //     deleteItems.push({
  //       bizCd: rowData.bizCd,
  //       seq: rowData.n02Seq,
  //       glfPrceCd: 'N02',
  //     })
  //   }

  //   if (rowData.m01Seq) {
  //     deleteItems.push({
  //       bizCd: rowData.bizCd,
  //       seq: rowData.m01Seq,
  //       glfPrceCd: 'M01',
  //     })
  //   }

  //   if (rowData.m02Seq) {
  //     deleteItems.push({
  //       bizCd: rowData.bizCd,
  //       seq: rowData.m02Seq,
  //       glfPrceCd: 'M02',
  //     })
  //   }

  //   return deleteItems
  // }

  const handleSelectedDelete = async (selectedData: SelectedRowData[]) => {
    try {
      // 모든 선택된 데이터의 이력 조회
      const allHistData = []
      for (const selected of selectedData) {
        const histResponse = await axios.post(
          '/priceIntgMgmt/histList',
          selected,
        )

        if (histResponse.status !== 200) {
          throw new Error(`${selected.bizCd} 이력 조회 실패`)
        }

        const histList = histResponse.data.data.list
        allHistData.push(...histList)
      }

      if (allHistData.length > 0) {
        const deleteResponse = await axios.post(
          '/priceIntgMgmt/delete',
          allHistData,
        )

        if (deleteResponse.status === 200) {
          // 선택 해제
          setSelectedRows([])
          setSelectAll(false)
          // 화면 갱신 완료 후 성공 알럿
          showAlert({
            type: 'success',
            message: '선택된 항목이 삭제되었어요.',
          })

          // 삭제 완료 후 화면 갱신
          await getData()
        } else {
          showAlert({
            type: 'error',
            message: '삭제 중 오류가 발생했어요.',
          })
        }
      } else {
        showAlert({
          type: 'error',
          message: '삭제할 이력이 없어요.',
        })
      }
    } catch (error) {
      showAlert({
        type: 'error',
        message: '삭제 중 오류가 발생했어요.',
      })
    }
  }

  // 전체 삭제 API 호출
  const handleAllDelete = async () => {
    try {
      // 조회할 때 사용한 검색 조건 그대로 사용
      const payload = {
        //areaCd: searchData.areaCd || '',
        bizCd: bizCd,
        //manualYn: searchData.manualYn || '',
        inqyStartDate: searchData.inqyStartDate.replaceAll('-', ''),
        inqyEndDate: searchData.inqyEndDate.replaceAll('-', ''),
        //glfPrceCd: searchData.glfPrceCd || '',
        //minPrce: searchData.minPrce || '',
        //maxPrce: searchData.maxPrce || '',
      }

      const response = await axios.post('/priceIntgMgmt/deleteAll', payload)
      if (response.data.success) {
        showAlert({
          type: 'success',
          message: `${searchData.inqyStartDate} ~ ${searchData.inqyEndDate} 기간의 모든 데이터가 삭제되었어요.`,
        })
      }
      setTimeout(() => {
        getData()
      }, 10)
    } catch (error) {
      console.error('전체 삭제 오류:', error)
      showAlert({
        type: 'error',
        message: '삭제 중 오류가 발생했습니다.',
      })
    }
  }

  const handleUpdateButtonClick = async (row: DataRow) => {
    const rowIndex = datas.findIndex(
      (data) => data.baseDt == row.baseDt && data.bizCd == row.bizCd,
    )
    if (rowIndex < 0) {
      showAlert({
        type: 'warning',
        message: '잘못된 접근입니다.',
      })
      console.log('가격이력 업데이트 대상 오류', row)
      return
    }

    const response = await axios.post('/priceIntgMgmt/update', [row])
    if (response.status === 200) {
      if (response.data.data.row > 0) {
        getData()
      }
    } else {
      showAlert({
        type: 'error',
        message: '가격이력 변경을 실패했습니다.',
      })
    }
  }

  const handleAllUpdateButtonClick = async (changeList: DataRow[]) => {
    if (changeList.length == 0) {
      showAlert({
        type: 'warning',
        message: '변경된 내용이 없습니다.',
      })
      return
    }
    const response = await axios.post('/priceIntgMgmt/update', changeList)
    if (response.status === 200) {
      if (response.data.data.row > 0) {
        getData()
      }
    } else {
      showAlert({
        type: 'error',
        message: '가격이력 변경을 실패했습니다.',
      })
    }
  }

  const handleWeeklyStatUpdateButtonClick = async (bizCd: string) => {
    if (!bizCd) {
      showAlert({
        type: 'warning',
        message: '배치 실행 할 골프장 정보가 없습니다.',
      })
      return
    }

    console.log('bizCd:', bizCd) // 디버깅용 로그
    const response = await axios.post('/priceStat/rebuildWeeklyStat', {
      bizCd: bizCd,
    })
    if (response.status === 200) {
      if (response.data.data.row === 0) {
        showAlert({
          type: 'warning',
          message: '변경된 과거 가격 이력 정보가 존재하지 않습니다.',
        })
      } else if (response.data.data.row > 0) {
        showAlert({
          type: 'success',
          message: '변경된 가격 정보 통계 반영 완료되었습니다.',
        })
      } else {
        showAlert({
          type: 'error',
          message: '통계 배치 실행 중 오류가 발생하였습니다.',
        })
      }
    } else {
      showAlert({
        type: 'error',
        message: '통계 배치 실행 실패하였습니다.',
      })
    }
  }

  const handleAllInsertButtonClick = async () => {
    if (insertDatas.length == 0) {
      showAlert({
        type: 'warning',
        message: '등록할 데이터가 없습니다.',
      })
      return
    }

    const response = await axios.post(
      '/priceIntgMgmt/insert',
      insertDatas.map((data) => ({
        ...data,
        baseDt: data.baseDt.replaceAll('-', ''),
      })),
    )
    if (response.status === 200) {
      setShowInsert(false)
      if (response.data.data.row > 0) {
        getData()
      }
    } else {
      showAlert({
        type: 'error',
        message: '가격이력 등록을 실패했습니다.',
      })
    }
  }

  const handleHistButtonClick = async (data: DataRow) => {
    console.log('handleHistButtonClick', data)
    const response = await axios.post('/priceIntgMgmt/histList', data)
    if (response.status === 200) {
      const list = response.data.data.list
      setTargetHistData(data)
      setHistOrigin(list)
      setHistDatas(list)
      setHistChangeFields(list.map(() => ({})))
      setShowHistList(true)
      setShowInsert(false)
      setSearchHistData(initHistSearch)
    } else {
      showAlert({
        type: 'error',
        message: '가격 이력 조회중 오류가 발생했습니다.',
        onClose: () => {
          // navigate(-1);
        },
      })
    }
  }

  const handleDeleteButton = async (data: HistDataRow) => {
    const response = await axios.post('/priceIntgMgmt/delete', [data])
    if (response.status === 200) {
      // 삭제이후 일종의 화면 갱신
      if (targetHistData) {
        handleHistButtonClick(targetHistData)
      }

      if (response.data.data.row > 0) {
        getData()
      }
    } else {
      showAlert({
        type: 'error',
        message: '가격 이력 삭제중 오류가 발생했습니다.',
      })
    }
  }

  const handleAllDeleteButton = async () => {
    if (histDatas.length == 0) {
      showAlert({
        type: 'warning',
        message: '삭제할 이력이 없습니다.',
      })
      return
    }
    const response = await axios.post('/priceIntgMgmt/delete', histDatas)
    if (response.status === 200) {
      // 삭제이후 일종의 화면 갱신
      if (targetHistData) {
        handleHistButtonClick(targetHistData)
      }

      if (response.data.data.row > 0) {
        getData()
      }
    } else {
      showAlert({
        type: 'error',
        message: '가격 이력 전체 삭제중 오류가 발생했습니다.',
      })
    }
  }

  const isDataChange = (row: DataRow, key: string) => {
    const rowIndex = datas.findIndex(
      (data) => data.baseDt == row.baseDt && data.bizCd == row.bizCd,
    )
    if (rowIndex < 0) {
      return
    }

    return changeFields[rowIndex] && changeFields[rowIndex][key]
  }

  const getData = async () => {
    const response = await axios.post('/priceIntgMgmt/list', {
      ...searchData,
      inqyStartDate: searchData.inqyStartDate.replaceAll('-', ''),
      inqyEndDate: searchData.inqyEndDate.replaceAll('-', ''),
    })
    if (response.status === 200) {
      const list = response.data.data.list
      setOrigin(list)
      setDatas(list)
      setChangeFields(list.map(() => ({})))
      // 첫 번째 항목 bizCd 뽑기 (예시)
      setBizCd(list[0]?.bizCd)
      console.log('bizCd:', bizCd)
    } else {
      showAlert({
        type: 'error',
        message: '가격 이력 조회중 오류가 발생했습니다.',
        onClose: () => {
          // navigate(-1);
        },
      })
    }
  }

  const getBizList = async () => {
    const response = await axios.get('/bizMgmt/list', {})
    if (response.status) {
      if (response.data) {
        setBizList(
          [...response.data].sort((a, b) => {
            if (a.bizNm < b.bizNm) return -1
            if (a.bizNm > b.bizNm) return 1
            return 0
          }),
        )
      } else {
        showAlert({
          type: 'error',
          message: '골프장 목록 조회중 오류가 발생했습니다.',
        })
      }
    } else {
      showAlert({
        type: 'error',
        message: '골프장 목록 조회중 오류가 발생했습니다.',
      })
    }
  }

  useEffect(() => {
    getData()
    getBizList()
  }, [])

  // 전체 선택 핸들러
  const handleSelectAll = (): void => {
    // 현재 페이지의 데이터 계산
    const startIndex = (currentPage - 1) * perPage
    const endIndex = startIndex + perPage
    const currentPageData = datas.slice(startIndex, endIndex)

    if (selectAll) {
      // 현재 페이지의 모든 행 해제
      const currentPageRows = currentPageData.map((row: DataRow) => ({
        bizCd: row.bizCd,
        baseDt: row.baseDt,
      }))

      // 현재 페이지 행들을 제외한 나머지 선택된 행들만 남김
      const remainingRows = selectedRows.filter(
        (selectedRow) =>
          !currentPageRows.some(
            (currentRow) =>
              currentRow.bizCd === selectedRow.bizCd &&
              currentRow.baseDt === selectedRow.baseDt,
          ),
      )

      setSelectedRows(remainingRows)
      setSelectAll(false)
    } else {
      // 현재 페이지의 모든 행 선택
      const currentPageRows = currentPageData.map((row: DataRow) => ({
        bizCd: row.bizCd,
        baseDt: row.baseDt,
      }))

      // 기존 선택된 행들 중 현재 페이지가 아닌 것들과 현재 페이지 행들을 합침
      const otherPageRows = selectedRows.filter(
        (selectedRow) =>
          !currentPageRows.some(
            (currentRow) =>
              currentRow.bizCd === selectedRow.bizCd &&
              currentRow.baseDt === selectedRow.baseDt,
          ),
      )

      setSelectedRows([...otherPageRows, ...currentPageRows])
      setSelectAll(true)
    }
  }

  const handleCheckboxClick = (row: DataRow): void => {
    const isCurrentlyChecked = selectedRows.some(
      (selectedRow) =>
        selectedRow.bizCd === row.bizCd && selectedRow.baseDt === row.baseDt,
    )

    let updatedSelectedRows: SelectedRowData[] = []

    if (!isCurrentlyChecked) {
      updatedSelectedRows = [
        ...selectedRows,
        { bizCd: row.bizCd, baseDt: row.baseDt },
      ]
    } else {
      updatedSelectedRows = selectedRows.filter(
        (selectedRow: SelectedRowData) =>
          !(
            selectedRow.bizCd === row.bizCd && selectedRow.baseDt === row.baseDt
          ),
      )
    }

    setSelectedRows(updatedSelectedRows)

    // 현재 페이지의 데이터 계산
    const startIndex = (currentPage - 1) * perPage
    const endIndex = startIndex + perPage
    const currentPageData = datas.slice(startIndex, endIndex)

    // 현재 페이지의 모든 행이 선택되었는지 확인
    const currentPageRows = currentPageData.map((row: DataRow) => ({
      bizCd: row.bizCd,
      baseDt: row.baseDt,
    }))

    const currentPageSelectedCount = currentPageRows.filter((currentRow) =>
      updatedSelectedRows.some(
        (selectedRow) =>
          selectedRow.bizCd === currentRow.bizCd &&
          selectedRow.baseDt === currentRow.baseDt,
      ),
    ).length

    // 현재 페이지의 모든 행이 선택되었을 때만 selectAll을 true로 설정
    setSelectAll(
      currentPageSelectedCount === currentPageRows.length &&
        currentPageRows.length > 0,
    )
  }

  const columns: TableColumn<DataRow>[] = [
    {
      cell: (row: DataRow, index: number) => (
        <input
          type="checkbox"
          checked={selectedRows.some(
            (selectedRow) =>
              selectedRow.bizCd === row.bizCd &&
              selectedRow.baseDt === row.baseDt,
          )}
          onClick={() => handleCheckboxClick(row)}
          style={{ cursor: 'pointer' }}
        />
      ),
      width: '10px',
      center: true,
    },
    {
      name: '골프장명',
      selector: (row) => row.bizNm,
      cell: (row) => {
        return (
          <a
            href={row.chrgeDomain || row.baseDomain}
            rel="noopener noreferrer"
            target="_blank"
          >
            {row.bizNm}
          </a>
        )
      },
      width: '13%',
      center: true,
    },
    {
      name: '기준일자',
      selector: (row) => commonUtils.dateStrChgFomat(row.baseDt, 'yyyy.MM.dd'),
      width: '8%',
      center: true,
    },
    {
      name: '비회원주중',
      selector: (row) => row.n01 || 0,
      cell: (row, index) => {
        return (
          <>
            <Input
              id={`n01${index}`}
              name="n01"
              type="text"
              className={isDataChange(row, 'n01') ? 'changed' : ''}
              value={Number(row.n01 || 0).toLocaleString()}
              onChange={(e) => handleInputChange(e, row)}
              style={{
                textAlign: 'right',
              }}
              disabled={!row.n01}
            />
          </>
        )
      },
      width: '10%',
      center: true,
    },
    {
      name: '비회원주말',
      selector: (row) => row.n02 || 0,
      cell: (row, index) => {
        return (
          <>
            <Input
              id={`n02${index}`}
              name="n02"
              type="text"
              className={isDataChange(row, 'n02') ? 'changed' : ''}
              value={Number(row.n02 || 0).toLocaleString()}
              onChange={(e) => handleInputChange(e, row)}
              style={{
                textAlign: 'right',
              }}
              disabled={!row.n02}
            />
          </>
        )
      },
      width: '10%',
      center: true,
    },
    {
      name: '회원주중',
      selector: (row) => row.m01 || 0,
      cell: (row, index) => {
        return (
          <>
            <Input
              id={`m01${index}`}
              name="m01"
              type="text"
              className={isDataChange(row, 'm01') ? 'changed' : ''}
              value={Number(row.m01 || 0).toLocaleString()}
              onChange={(e) => handleInputChange(e, row)}
              style={{
                textAlign: 'right',
              }}
              disabled={!row.m01}
            />
          </>
        )
      },
      width: '10%',
      center: true,
    },
    {
      name: '회원주말',
      selector: (row) => row.m02 || 0,
      cell: (row, index) => {
        return (
          <>
            <Input
              id={`m02${index}`}
              name="m02"
              type="text"
              className={isDataChange(row, 'm02') ? 'changed' : ''}
              value={Number(row.m02 || 0).toLocaleString()}
              onChange={(e) => handleInputChange(e, row)}
              style={{
                textAlign: 'right',
              }}
              disabled={!row.m02}
            />
          </>
        )
      },
      width: '10%',
      center: true,
    },
    {
      name: '비고',
      selector: (row) => row.rem,
      cell: (row, index) => {
        return (
          <span
            title={row.rem}
            style={{
              marginRight: 'auto',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '150px',
            }}
          >
            {row.rem}
          </span>
        )
      },
      center: true,
      width: '15%',
    },
    {
      name: '수정일시',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate, true),
      wrap: true,
      width: '8%',
      center: true,
    },
    {
      name: '',
      cell: (row, index) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleResetButtonClick(row)}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            color="neverbe"
            size="xs"
            onClick={() => {
              showConfirm({
                message: '가격이력을 변경하시겠습니까?',
                onConfirm: () => {
                  handleUpdateButtonClick(row)
                },
              })
            }}
          >
            저장
          </Button>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleHistButtonClick(row)}
          >
            이력
          </Button>
        </>
      ),
      sortable: false,
      width: '15%',
      center: true,
    },
  ]

  return (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          width: '100%',
          display: 'flex',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <style>
          {`
            .changed {
              background-color: yellow;
            }
          `}
        </style>
        <p style={{ fontSize: '20px' }}>통합가격이력관리</p>
        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <FormGroup>
              <Label htmlFor={'areaCd'}>지역</Label>
              <div style={{ marginBottom: '3px' }} />
              <Select
                id="areaCd"
                name="areaCd"
                width="100px"
                onChange={handleSearchChange}
                value={searchData.areaCd}
              >
                {getComCodes('AREA_CD').map((item) => (
                  <option key={'areaCd' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'manualYn'}>수기관리여부</Label>
              <div style={{ marginBottom: '3px' }} />
              <Select
                id="manualYn"
                name="manualYn"
                width="90px"
                onChange={handleSearchChange}
                value={searchData.manualYn}
              >
                <option value={''}>전체</option>
                {getComCodes('MANUAL_YN').map((item) => (
                  <option key={'manualYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'bizNm'}>골프장명</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="bizNm"
                  name="bizNm"
                  type="text"
                  width="200px"
                  value={searchData.bizNm}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'inqyStartDate'}>조회시작일</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="inqyStartDate"
                  name="inqyStartDate"
                  type="date"
                  value={searchData.inqyStartDate}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'inqyEndDate'}>조회종료일</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="inqyEndDate"
                  name="inqyEndDate"
                  type="date"
                  value={searchData.inqyEndDate}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'glfPrceCd'}>가격코드</Label>
              <div style={{ marginBottom: '3px' }} />
              <Select
                id="glfPrceCd"
                name="glfPrceCd"
                width="100px"
                onChange={handleSearchChange}
                value={searchData.glfPrceCd}
              >
                {getComCodes('GLF_PRCE_CD').map((item) => (
                  <option key={'glfPrceCd' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'inqyStartDate'}>최소금액</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="minPrce"
                  name="minPrce"
                  type="text"
                  width="150px"
                  value={searchData.minPrce}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'maxPrce'}>최대금액</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="maxPrce"
                  name="maxPrce"
                  type="text"
                  width="150px"
                  value={searchData.maxPrce}
                  onChange={handleSearchChange}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper gap="3px">
                <Button onClick={getData} color="neverbe" variant="outlined">
                  검색
                </Button>
                <Button
                  onClick={() => {
                    handleInsertButtonClick()
                  }}
                  color="neverbe"
                  variant="contained"
                >
                  등록
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
        </div>
      </div>
      <div
        style={{
          width: '100%',
          marginBottom: '10px',
          display: 'flex',
        }}
      >
        <div
          style={{
            marginBottom: '10px',
            display: 'flex',
            marginTop: '20px',
            gap: '5px',
          }}
        >
          <div style={{ alignSelf: 'flex-end', marginRight: '20px' }}>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                fontSize: '14px',
                marginLeft: '10px',
              }}
            >
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                style={{ cursor: 'pointer' }}
              />
              현재 페이지 전체 선택
            </label>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                fontSize: '12px',
                marginLeft: '10px',
                color: 'red',
                marginTop: '2px',
              }}
            >
              *모든 요금 삭제는 전체삭제 버튼 사용
            </label>
          </div>
          <div>
            <Button
              onClick={handleSelectedDeleteClick}
              color={'success'}
              variant="contained"
            >
              {'선택삭제'}
            </Button>
          </div>
          <div>
            <Button
              onClick={handleAllDeleteClick}
              color={'danger'}
              variant="contained"
            >
              {'전체삭제'}
            </Button>
          </div>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <FormGroup>
              <Label htmlFor={'n01Apply'}>비회원주중</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="n01Apply"
                  name="n01"
                  type="text"
                  width="150px"
                  value={applyData.n01}
                  onChange={handleApplyChange}
                  // onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'n02Apply'}>비회원주말</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="n02Apply"
                  name="n02"
                  type="text"
                  width="150px"
                  value={applyData.n02}
                  onChange={handleApplyChange}
                  // onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'m01Apply'}>회원주중</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="m01Apply"
                  name="m01"
                  type="text"
                  width="150px"
                  value={applyData.m01}
                  onChange={handleApplyChange}
                  // onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'m02Apply'}>회원주말</Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper>
                <Input
                  id="m02Apply"
                  name="m02"
                  type="text"
                  width="150px"
                  value={applyData.m02}
                  onChange={handleApplyChange}
                  // onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <div style={{ marginBottom: '3px' }} />
              <FlexWrapper gap="3px">
                <Button
                  onClick={() => handleApplyButton()}
                  color="neverbe"
                  variant="outlined"
                >
                  일괄적용
                </Button>
                <Button
                  variant="outlined"
                  color="neverbe"
                  size="md"
                  onClick={() => {
                    setApplyData({
                      n01: '',
                      n02: '',
                      m01: '',
                      m02: '',
                    })
                    setDatas(origin)
                    setChangeFields(origin.map(() => ({})))
                  }}
                >
                  Reset
                </Button>
                <Button
                  onClick={() => {
                    const start = (currentPage - 1) * perPage
                    const end = start + perPage
                    const changeList = changeFields
                      .slice(start, end)
                      .map((item, index) => {
                        const hasTrue = Object.values(item).some(
                          (v) => v === true,
                        )
                        return hasTrue ? index + start : -1
                      })
                      .filter((index) => index !== -1)

                    // TODO 변경된 부분만 업데이트하기
                    if (changeList.length == 0) {
                      showAlert({
                        type: 'warning',
                        message: '변경된 내용이 없습니다.',
                        // onConfirm: () => {
                        //   handleAllUpdateButtonClick();
                        // }
                      })
                    } else {
                      showConfirm({
                        message: '일괄 변경 하시겠습니까?',
                        onConfirm: () => {
                          handleAllUpdateButtonClick(
                            changeList.map((index) => datas[index]),
                          )
                        },
                      })
                    }
                  }}
                  color="neverbe"
                  variant="contained"
                >
                  일괄변경
                </Button>
                <Button
                  onClick={() => {
                    if (!searchData.bizNm || !searchData.bizNm.trim()) {
                      showAlert({
                        type: 'warning',
                        message: '골프장명 검색 후 실행 해주세요.',
                      })
                      return
                    }
                    const start = (currentPage - 1) * perPage
                    const end = start + perPage
                    const changeList = changeFields
                      .slice(start, end)
                      .map((item, index) => {
                        const hasTrue = Object.values(item).some(
                          (v) => v === true,
                        )
                        return hasTrue ? index + start : -1
                      })
                      .filter((index) => index !== -1)

                    // 검색된 업체의 bizCd 추출
                    const matchedBiz = bizList.find((biz) =>
                      biz.bizNm.includes(searchData.bizNm),
                    )
                    const bizCd = matchedBiz ? matchedBiz.bizCd : ''

                    const changedData = changeList.map((index) => datas[index])
                    showConfirm({
                      message: `${searchData.bizNm}의 변경된 가격 정보를 통계에 반영하시겠습니까?\n확인 버튼 클릭 시 통계 배치가 실행됩니다.`,
                      onConfirm: () => {
                        handleWeeklyStatUpdateButtonClick(bizCd)
                      },
                    })
                  }}
                  color="secondary"
                  variant="contained"
                  disabled={!searchData.bizNm}
                >
                  배치실행
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={datas}
        pagination={true}
        paginationPerPage={50}
        paginationRowsPerPageOptions={[50, 100, 200]}
        defaultSortAsc={false}
        onChangeRowsPerPage={setPerPage}
        onChangePage={(page) => {
          setCurrentPage(page)
        }}
        noDataComponent={<>조회결과가 없습니다.</>}
      />

      {
        // 이력목록
        showHistList && (
          <div
            style={{
              position: 'fixed' /* 화면에 고정 */,
              top: '10%',
              width: '90%' /* 너비 조정 */,
              padding: '25px',
              zIndex: '5' /* 다른 요소 위에 표시 */,
              background: 'white',
              border: '1px solid',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
                marginBottom: '10px',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '20px', marginLeft: '20px' }}>
                가격이력조회
              </p>
              <div style={{ marginLeft: 'auto', marginRight: '50px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <FlexWrapper gap="20px">
                    <FormGroup>
                      <Label htmlFor={'targetBizNm'}>골프장명</Label>
                      <Input
                        id="targetBizNm"
                        name="targetBizNm"
                        value={targetHistData?.bizNm || '-'}
                        disabled
                        width={'20rem'}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={'targetBaseDt'}>기준일자</Label>
                      <Input
                        id="targetBaseDt"
                        name="targetBaseDt"
                        value={
                          targetHistData?.baseDt
                            ? commonUtils.dateStrChgFomat(
                                targetHistData.baseDt,
                                'yyyy.MM.dd',
                              )
                            : ''
                        }
                        disabled
                        width={'8rem'}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={'glfPrceCdHist'}>가격코드</Label>
                      <Select
                        id="glfPrceCdHist"
                        name="glfPrceCd"
                        width="100px"
                        value={searchHistData.glfPrceCd}
                        onChange={handleHistSearchChange}
                      >
                        <option value={''}>전체</option>
                        {getComCodes('GLF_PRCE_CD').map((item) => (
                          <option
                            key={'glfPrceCd' + item.code}
                            value={item.code}
                          >
                            {item.codeNm}
                          </option>
                        ))}
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={'updtYnApplyHist'}>업데이트여부</Label>
                      <Select
                        id="updtYnApplyHist"
                        name="updtYn"
                        value={searchHistData.updtYn}
                        onChange={handleHistSearchChange}
                      >
                        <option value={''}>전체</option>
                        {getComCodes('UPDT_YN').map((item) => (
                          <option
                            key={'updtYnApply' + item.code}
                            value={item.code}
                          >
                            {item.codeNm}
                          </option>
                        ))}
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={'statInclYnApplyHist'}>
                        통계포함여부
                      </Label>
                      <Select
                        id="statInclYnApplyHist"
                        name="statInclYn"
                        value={searchHistData.statInclYn}
                        onChange={handleHistSearchChange}
                      >
                        <option value={''}>전체</option>
                        {getComCodes('STAT_INCL_YN').map((item) => (
                          <option
                            key={'statInclYnApply' + item.code}
                            value={item.code}
                          >
                            {item.codeNm}
                          </option>
                        ))}
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={''}>
                        <></>
                      </Label>
                      <FlexWrapper gap="10px">
                        <Button
                          onClick={() => {
                            showConfirm({
                              message: '가격 이력을 전체 삭제하시겠습니까?',
                              onConfirm: () => {
                                handleAllDeleteButton()
                              },
                            })
                          }}
                          color="neverbe"
                          variant="contained"
                        >
                          전체삭제
                        </Button>
                      </FlexWrapper>
                    </FormGroup>
                  </FlexWrapper>
                </div>
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '10px',
                }}
              >
                <Button
                  variant="texted"
                  color="neverbe"
                  fontSize={'x-large'}
                  onClick={() => {
                    setShowHistList(false)
                  }}
                  margin={'10px'}
                >
                  ⨉
                </Button>
              </div>
            </div>
            <div
              style={{
                overflowX: 'auto',
                overflowY: 'hidden',
                maxWidth: '100%',
              }}
            >
              <DataTable
                columns={
                  [
                    {
                      name: '가격코드',
                      selector: (row) =>
                        getComCodeValue('GLF_PRCE_CD', row.glfPrceCd)?.codeNm ||
                        row.glfPrceCd,
                      width: '8%',
                      center: true,
                    },
                    {
                      name: '순번',
                      selector: (row) => row.seq,
                      width: '5%',
                      center: true,
                    },
                    // {
                    //   name: '이전가격',
                    //   selector: (row) => Number(row.oldPrce || 0).toLocaleString(),
                    //   cell: (row) => {
                    //     return <p style={{ marginLeft: 'auto' }}>{Number(row.oldPrce || 0).toLocaleString()}</p>
                    //   },
                    //   width: '10%',
                    //   center: true,
                    // },
                    {
                      name: '신규가격',
                      selector: (row) =>
                        Number(row.newPrce || 0).toLocaleString(),
                      // cell: (row, index) => {
                      //   return <>
                      //     <Input
                      //       id="newPrce"
                      //       name="newPrce"
                      //       type="text"
                      //       // className={isDataChange(index, 'newPrce') ? 'changed' : ''}
                      //       value={Number(row.newPrce || 0).toLocaleString()}
                      //       // onChange={(e) => handleInputChange(e, index)}
                      //       style={{
                      //         textAlign: 'right',
                      //       }}
                      //     />
                      //   </>
                      // },
                      width: '10%',
                      center: true,
                    },
                    {
                      name: '업데이트여부',
                      selector: (row) =>
                        getComCodeValue('UPDT_YN', row.updtYn)?.codeNm ||
                        row.updtYn,
                      // cell: (row, index) => (
                      //   <Select
                      //     id="updtYn"
                      //     name="updtYn"
                      //     // className={isDataChange(index, 'updtYn') ? 'changed' : ''}
                      //     // onChange={(e) => handleInputChange(e, index)}
                      //     value={row.updtYn || ''}
                      //   >
                      //     {getComCodes('UPDT_YN').map((item) => (
                      //       <option key={'updtYn' + item.code} value={item.code}>
                      //         {item.codeNm}
                      //       </option>
                      //     ))}
                      //   </Select>
                      // ),
                      width: '9%',
                      center: true,
                    },
                    {
                      name: '통계포함여부',
                      selector: (row) =>
                        getComCodeValue('STAT_INCL_YN', row.statInclYn)
                          ?.codeNm || row.statInclYn,
                      // cell: (row, index) => (
                      //   <Select
                      //     id="statInclYn"
                      //     name="statInclYn"
                      //     // className={isDataChange(index, 'statInclYn') ? 'changed' : ''}
                      //     // onChange={(e) =>
                      //     //   handleInputChange(e, index)
                      //     // }
                      //     value={row.statInclYn || ''}
                      //   >
                      //     {getComCodes('STAT_INCL_YN').map((item) => (
                      //       <option key={'statInclYn' + item.code} value={item.code}>
                      //         {item.codeNm}
                      //       </option>
                      //     ))}
                      //   </Select>
                      // ),
                      width: '9%',
                      center: true,
                    },
                    {
                      name: '비고',
                      selector: (row) => row.rem || '',
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id="rem"
                              name="rem"
                              type="text"
                              // className={isDataChange(index, 'rem') ? 'changed' : ''}
                              // onChange={(e) => handleInputChange(e, index)}
                              value={row.rem || ''}
                              disabled
                            />
                          </>
                        )
                      },
                      width: '14%',
                      center: true,
                    },
                    {
                      name: '오류내용',
                      selector: (row) => row.rem || '',
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id="rem"
                              name="rem"
                              type="text"
                              // className={isDataChange(index, 'rem') ? 'changed' : ''}
                              // onChange={(e) => handleInputChange(e, index)}
                              value={row.errDtl || ''}
                              disabled
                            />
                          </>
                        )
                      },
                      width: '20%',
                      center: true,
                    },
                    {
                      name: '수정자',
                      selector: (row) => row.updId,
                      sortable: true,
                      center: true,
                      wrap: true,
                      width: '9%',
                    },
                    {
                      name: '수정일시',
                      selector: (row) => row.updDate,
                      format: (row) =>
                        commonUtils.formatDate(row.updDate, true),
                      sortable: true,
                      wrap: true,
                      width: '9%',
                      center: true,
                    },
                    {
                      name: '',
                      cell: (row, index) => (
                        <>
                          <Button
                            variant="outlined"
                            color="neverbe"
                            size="xs"
                            onClick={() => {
                              showConfirm({
                                message: '가격 이력을 삭제하시겠습니까?',
                                onConfirm: () => {
                                  handleDeleteButton(row)
                                },
                              })
                            }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                      width: '7%',
                    },
                  ] as TableColumn<HistDataRow>[]
                } // 컬럼정보(header)
                data={histDatas} // 화면에 표시될 데이터
                pagination={false}
                fixedHeader
                fixedHeaderScrollHeight={'30rem'}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10]}
                defaultSortAsc={false}
                noDataComponent={<>조회결과가 없습니다.</>}
              />
            </div>
          </div>
        )
      }

      {
        // 이력등록
        showInsert && (
          <div
            style={{
              position: 'fixed' /* 화면에 고정 */,
              top: '10%',
              width: '90%' /* 너비 조정 */,
              padding: '25px',
              zIndex: '5' /* 다른 요소 위에 표시 */,
              background: 'white',
              border: '1px solid',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'right',
                width: '100%',
                marginBottom: '10px',
                alignItems: 'center',
              }}
            >
              <p style={{ fontSize: '20px', marginLeft: '20px' }}>
                가격이력등록
              </p>
              <div style={{ marginLeft: 'auto', marginRight: '50px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <FlexWrapper gap="20px">
                    <FormGroup>
                      <Label htmlFor={'insertBizCd'}>골프장명</Label>
                      <Select
                        id="insertBizCd"
                        name="bizCd"
                        value={searchInsertData.bizCd}
                        onChange={handleInsertSearchChange}
                      >
                        <option value={''}>선택</option>
                        {bizList.map((item) => (
                          <option key={'bizNm' + item.bizCd} value={item.bizCd}>
                            {item.bizNm}
                          </option>
                        ))}
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor={''}>
                        <></>
                      </Label>
                      <FlexWrapper gap="10px">
                        <Button
                          onClick={() => {
                            if (!searchInsertData.bizCd) {
                              showAlert({
                                type: 'warning',
                                message: '골프장을 선택하세요.',
                              })
                              return
                            }
                            setInsertDatas([
                              ...insertDatas,
                              {
                                ...initInsertData,
                                bizCd: searchInsertData.bizCd,
                                bizNm:
                                  bizList.find(
                                    (biz) =>
                                      biz.bizCd === searchInsertData.bizCd,
                                  )?.bizNm || searchInsertData.bizCd,
                              },
                            ])
                          }}
                          color="neverbe"
                          variant="contained"
                        >
                          행추가
                        </Button>
                      </FlexWrapper>
                    </FormGroup>
                  </FlexWrapper>
                </div>
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '10px',
                }}
              >
                <Button
                  variant="texted"
                  color="neverbe"
                  fontSize={'x-large'}
                  onClick={() => {
                    setShowInsert(false)
                  }}
                  margin={'10px'}
                >
                  ⨉
                </Button>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: 'auto' }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <FormGroup>
                    <Label htmlFor={'n01ApplyInsert'}>비회원주중</Label>
                    <FlexWrapper>
                      <Input
                        id="n01ApplyInsert"
                        name="n01"
                        type="text"
                        width="150px"
                        value={applyInsertData.n01}
                        onChange={handleApplyInsertChange}
                        // onKeyDown={handleKeyDown}
                      />
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={'n02ApplyInsert'}>비회원주말</Label>
                    <FlexWrapper>
                      <Input
                        id="n02ApplyInsert"
                        name="n02"
                        type="text"
                        width="150px"
                        value={applyInsertData.n02}
                        onChange={handleApplyInsertChange}
                        // onKeyDown={handleKeyDown}
                      />
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={'m01ApplyInsert'}>회원주중</Label>
                    <FlexWrapper>
                      <Input
                        id="m01ApplyInsert"
                        name="m01"
                        type="text"
                        width="150px"
                        value={applyInsertData.m01}
                        onChange={handleApplyInsertChange}
                        // onKeyDown={handleKeyDown}
                      />
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={'m02ApplyInsert'}>회원주말</Label>
                    <FlexWrapper>
                      <Input
                        id="m02ApplyInsert"
                        name="m02"
                        type="text"
                        width="150px"
                        value={applyInsertData.m02}
                        onChange={handleApplyInsertChange}
                        // onKeyDown={handleKeyDown}
                      />
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={'remApplyInsert'}>비고</Label>
                    <FlexWrapper>
                      <Input
                        id="remApplyInsert"
                        name="rem"
                        type="text"
                        width="150px"
                        value={applyInsertData.rem}
                        onChange={handleApplyInsertChange}
                        // onKeyDown={handleKeyDown}
                      />
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={''}>
                      <></>
                    </Label>
                    <FlexWrapper gap="10px">
                      <Button
                        onClick={() => handleInsertApplyButton()}
                        color="neverbe"
                        variant="outlined"
                      >
                        일괄적용
                      </Button>
                    </FlexWrapper>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor={''}>
                      <></>
                    </Label>
                    <FlexWrapper gap="10px">
                      <Button
                        onClick={() => {
                          showConfirm({
                            message: '일괄 저장 하시겠습니까?',
                            onConfirm: () => {
                              handleAllInsertButtonClick()
                            },
                          })
                        }}
                        color="neverbe"
                        variant="contained"
                      >
                        일괄저장
                      </Button>
                    </FlexWrapper>
                  </FormGroup>
                </div>
              </div>
            </div>
            <div
              style={{
                overflowX: 'auto',
                overflowY: 'hidden',
                maxWidth: '100%',
              }}
            >
              <DataTable
                columns={
                  [
                    {
                      name: '골프장명',
                      selector: (row) => row.bizNm,
                      width: '20%',
                      center: true,
                    },
                    {
                      name: '기준일자',
                      selector: (row) =>
                        commonUtils.dateStrChgFomat(row.baseDt, 'yyyy.MM.dd'),
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertBaseDt${index}`}
                              name="baseDt"
                              type="date"
                              value={row.baseDt}
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                            />
                          </>
                        )
                      },
                      width: '12%',
                      center: true,
                    },
                    {
                      name: '비회원주중',
                      selector: (row) => row.n01 || 0,
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertN01${index}`}
                              name="n01"
                              type="text"
                              value={
                                row.n01 ? Number(row.n01).toLocaleString() : ''
                              }
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                              style={{
                                textAlign: 'right',
                              }}
                            />
                          </>
                        )
                      },
                      width: '10%',
                      center: true,
                    },
                    {
                      name: '비회원주말',
                      selector: (row) => row.n02 || 0,
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertN02${index}`}
                              name="n02"
                              type="text"
                              value={
                                row.n02 ? Number(row.n02).toLocaleString() : ''
                              }
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                              style={{
                                textAlign: 'right',
                              }}
                            />
                          </>
                        )
                      },
                      width: '10%',
                      center: true,
                    },
                    {
                      name: '회원주중',
                      selector: (row) => row.m01 || 0,
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertM01${index}`}
                              name="m01"
                              type="text"
                              value={
                                row.m01 ? Number(row.m01).toLocaleString() : ''
                              }
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                              style={{
                                textAlign: 'right',
                              }}
                            />
                          </>
                        )
                      },
                      width: '10%',
                      center: true,
                    },
                    {
                      name: '회원주말',
                      selector: (row) => row.m02 || 0,
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertM02${index}`}
                              name="m02"
                              type="text"
                              value={
                                row.m02 ? Number(row.m02).toLocaleString() : ''
                              }
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                              style={{
                                textAlign: 'right',
                              }}
                            />
                          </>
                        )
                      },
                      width: '10%',
                      center: true,
                    },
                    {
                      name: '비고',
                      selector: (row) => row.rem,
                      cell: (row, index) => {
                        return (
                          <>
                            <Input
                              id={`insertRem${index}`}
                              name={'rem'}
                              value={row.rem}
                              onChange={(e) =>
                                handleInsertInputChange(e, index)
                              }
                            />
                          </>
                        )
                      },
                      center: true,
                      width: '15%',
                    },
                  ] as TableColumn<DataRow>[]
                } // 컬럼정보(header)
                data={insertDatas} // 화면에 표시될 데이터
                pagination={false}
                fixedHeader
                fixedHeaderScrollHeight={'30rem'}
                paginationPerPage={10}
                noDataComponent={<>행추가를 해주세요.</>}
              />
            </div>
          </div>
        )
      }
    </>
  )
}

export default PriceIntgMgmt
